import { FaFacebookMessenger, FaGift } from 'react-icons/fa';

import {
  IoMdImages,
  IoMdAnalytics,
  IoIosTrendingUp,
  IoMdChatbubbles,
} from 'react-icons/io';

import {
  MdOutlineVpnKey,
  MdOutlinePeopleAlt,
  MdInsertChartOutlined,
} from 'react-icons/md';

import {
  GiJigsawPiece,
  GiRadarDish,
  GiAmericanFootballHelmet,
  GiAcousticMegaphone,
  GiEightBall,
} from 'react-icons/gi';

import { ROLES } from 'consts';

import AgencyAnalytics from './AgencyAnalytics';
import AgencyCode from './AgencyCode';
import Analytics from './Analytics';
import Campaign from './Campaign';
import ChannelAdmin from './Channel/admin';
import ChannelHost from './Channel/host';
import Draw from './Draw';
import ImageLibrary from './ImageLibrary';
import InfluencerAnalytics from './InfluencerAnalytics';
import MessageFlow from './MessageFlow';
import PassKitInfo from './PassKitInfo';
import SportsApi from './SportsApi';
import Template from './Template';
import Users from './Users';

export { default as Dashboard } from './Dashboard/Dashboard';

export const routes = [
  {
    path: 'agency',
    component: AgencyCode,
    icon: MdOutlineVpnKey,
    title: 'Agency Code',
    allow: [ROLES.AGENCY, ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: 'agencyAnalytics',
    component: AgencyAnalytics,
    icon: IoMdAnalytics,
    title: 'Agency Analytics',
    allow: [ROLES.AGENCY],
  },
  {
    path: 'influencerAnalytics',
    component: InfluencerAnalytics,
    icon: IoIosTrendingUp,
    title: 'Influencer Analytics',
    allow: [ROLES.INFLUENCER],
  },
  {
    path: 'campaign',
    component: Campaign,
    icon: GiAcousticMegaphone,
    title: 'Campaign',
    allow: [ROLES.BCLC, ROLES.SUPERADMIN],
  },
  {
    path: 'users',
    component: Users,
    icon: MdOutlinePeopleAlt,
    title: 'Users & Groups',
    allow: [ROLES.USERS, ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: 'template',
    component: Template,
    icon: GiJigsawPiece,
    title: 'Templates',
    allow: [ROLES.TEMPLATE, ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: 'flow',
    component: MessageFlow,
    icon: IoMdChatbubbles,
    title: 'Message Flow',
    allow: [ROLES.FLOW, ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: 'draw',
    component: Draw,
    icon: GiEightBall,
    title: 'Lottery',
    allow: [ROLES.DRAW, ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: 'channel/admin',
    component: ChannelAdmin,
    icon: FaFacebookMessenger,
    title: 'Admin Channel Control',
    allow: [ROLES.CHANNELADMIN, ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: 'channel/host',
    component: ChannelHost,
    icon: GiAmericanFootballHelmet,
    title: 'Host Event Manager',
    allow: [ROLES.CHANNELHOST, ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: 'sportsapi',
    component: SportsApi,
    icon: GiRadarDish,
    title: 'Sports API Settings',
    allow: [ROLES.SPORTRADAR, ROLES.SUPERADMIN],
  },
  {
    path: 'analytics',
    component: Analytics,
    icon: MdInsertChartOutlined,
    title: 'Analytics',
    allow: [ROLES.ANALYTICS, ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: 'imageLibrary',
    component: ImageLibrary,
    icon: IoMdImages,
    title: 'Image Library',
    allow: [ROLES.IMAGELIBRARY, ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: 'passKitInfo',
    component: PassKitInfo,
    icon: FaGift,
    title: 'PassKit',
    allow: [ROLES.PASSKITINFO, ROLES.SUPERADMIN],
  },
];
